import React, { useEffect, useState } from 'react'

import { Col, Modal, Row } from 'react-bootstrap'
import { Button, Paragraph, FormText } from 'src/components'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { useDispatch, useSelector } from 'react-redux'
import { isAllowed } from 'src/selectors/modules.selector'
import { actions, getUserPin, updateUserPin } from 'src/actions/userPin.actions'
import { haveAnyValue } from 'src/utils/utilitiesV2'
import { loadingSelector } from 'src/selectors/loading.selector'
import {
  handlerError,
  handlerInfo,
  handlerSuccess,
  hasErrors,
} from 'src/selectors/error.selector'
import { selectUserPinResponse } from 'src/selectors/userPin.selector'
import { showAlert } from 'src/actions/alert.actions'

interface IFlags {
  get: boolean
  update: boolean
}

export interface IUser {
  name: string
  email: string
  id: number
}

interface IUserCompanyPINProps {
  user?: IUser
  onHide: () => void
}
export const UserCompanyPIN = ({ user, onHide }: IUserCompanyPINProps) => {
  const dispatch = useDispatch()

  const canUpdatePIN = useSelector(state => isAllowed(state, [1459]))

  const open = haveAnyValue(user?.id)

  const userPinResponse = useSelector(selectUserPinResponse)
  const loadingGet = useSelector(state => loadingSelector([actions.GET_USER_PIN])(state))
  const errorGet = useSelector(state => hasErrors([actions.GET_USER_PIN])(state))

  const loadingUpdate = useSelector(state =>
    loadingSelector([actions.UPDATE_USER_PIN])(state),
  )
  const errorUpdate = useSelector(state => hasErrors([actions.UPDATE_USER_PIN])(state))

  const loading = loadingGet || loadingUpdate

  const [pin, setPin] = useState<string | undefined>(undefined)
  const [flag, setFlag] = useState<IFlags>({
    get: false,
    update: false,
  })

  useEffect(() => {
    if (!open) return
    dispatch(getUserPin(user.id))
  }, [open])

  useEffect(() => {
    if (loadingGet) setFlag({ ...flag, get: true })
    else if (flag.get) {
      setFlag({ ...flag, get: false })
      if (errorGet) dispatch(showAlert(handlerError(errorGet.message)))
      else {
        setPin(userPinResponse?.data)
      }
    }
  }, [loadingGet])

  useEffect(() => {
    if (loadingUpdate) setFlag({ ...flag, update: true })
    else if (flag.update) {
      setFlag({ ...flag, update: false })

      const alert = errorUpdate ? handlerError(errorUpdate.message) : handlerSuccess()

      dispatch(showAlert(alert))
    }
  }, [loadingUpdate])

  const onClose = () => {
    onHide()
    setPin(undefined)
  }

  const onUpdate = () => {
    if (haveAnyValue(pin) && pin.length !== 4) {
      dispatch(
        showAlert({
          ...handlerInfo('PIN invalido', 'El PIN debe tener 4 dígitos.'),
        }),
      )
      return
    }

    dispatch(
      updateUserPin({
        userId: user.id,
        pin,
      }),
    )
  }

  return (
    <Modal show={open} centered onHide={onClose}>
      <Modal.Header closeButton={!loading}>
        <Modal.Title>{user?.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xl={12}>
            <Paragraph>El uso del PIN es únicamente en la APP de kolo.</Paragraph>
          </Col>
          <Col xl={12}>
            <Paragraph>{user?.email}</Paragraph>
          </Col>
          <Col xl={12}>
            <FormText
              label={'PIN'}
              value={pin}
              max={4}
              changeValue={setPin}
              disabled={loading}
            />
          </Col>
        </Row>
      </Modal.Body>
      {canUpdatePIN && (
        <Modal.Footer>
          <Row className={'container-buttons'}>
            <Button icon={faCheck} onClick={onUpdate} loading={loading}>
              Actualizar PIN
            </Button>
          </Row>
        </Modal.Footer>
      )}
    </Modal>
  )
}
